import { getLocalValue, LoacalVariables } from "./CommonFunctions";

// Staff sub-accounts only see the modules the vendor enabled for them (login response `enabledModules`).
// Vendor owners have no restriction.
// Each entry maps a route prefix to the module names that unlock it. Names are compared ignoring
// case, spaces and underscores. Routes that match nothing here are owner-only.
const ROUTE_MODULES: { prefix: string; modules: string[] }[] = [
  { prefix: "/dashboard", modules: ["Dashboard"] },
  { prefix: "/lab-overview", modules: ["Dashboard"] },

  { prefix: "/lab-orders", modules: ["Orders"] },
  { prefix: "/lab-assign-order", modules: ["Orders"] },
  { prefix: "/lab-scanning", modules: ["Orders"] },
  { prefix: "/pharmacy-orders", modules: ["Orders"] },
  { prefix: "/pharmacy-order-details", modules: ["Orders"] },
  { prefix: "/prescription", modules: ["Orders"] },
  { prefix: "/assign-order", modules: ["Orders"] },
  { prefix: "/lab-notifications", modules: ["Orders"] },
  { prefix: "/pharmacy-notifications", modules: ["Orders"] },

  { prefix: "/lab-technician", modules: ["Technicians"] },
  { prefix: "/technician-management", modules: ["Technicians"] },
  { prefix: "/technician-details", modules: ["Technicians"] },

  { prefix: "/lab-tests", modules: ["Tests", "LabTests"] },
  { prefix: "/lab-packages", modules: ["Packages", "LabPackages", "Tests", "LabTests"] },
  { prefix: "/lab-test-package", modules: ["Tests", "LabTests", "Packages", "LabPackages"] },
  { prefix: "/labtestpackage", modules: ["Tests", "LabTests", "Packages", "LabPackages"] },
  { prefix: "/lab-schedule", modules: ["Schedules", "Schedule"] },
  { prefix: "/lab-report", modules: ["Reports", "Report", "LabReports"] },
  { prefix: "/labreport", modules: ["Reports", "Report", "LabReports"] },
  { prefix: "/lab-category", modules: ["Categories", "Category", "LabCategory"] },
  { prefix: "/scan-", modules: ["Scanning", "Scan"] },
  { prefix: "/revenue", modules: ["Revenue", "Payments", "RevenuePayments"] },
  { prefix: "/payment", modules: ["Revenue", "Payments", "RevenuePayments"] },
  { prefix: "/vendor-product", modules: ["Products", "Product"] },
];

// Always reachable by a signed-in staff member
const OPEN_PREFIXES = ["/profile", "/logout"];

const normalize = (name: string) => String(name).toLowerCase().replace(/[\s_-]+/g, "");

export const isStaffAccount = () => getLocalValue(LoacalVariables.IsStaff) === "true";

const getEnabledModules = (): string[] => {
  try {
    const parsed = JSON.parse(getLocalValue(LoacalVariables.EnabledModules) || "[]");
    return Array.isArray(parsed) ? parsed.map(normalize) : [];
  } catch {
    return [];
  }
};

export const canAccessPath = (path: string): boolean => {
  if (!isStaffAccount()) return true;
  if (OPEN_PREFIXES.some((p) => path.startsWith(p))) return true;
  const rule = ROUTE_MODULES.find((r) => path.startsWith(r.prefix));
  if (!rule) return false;
  const enabled = getEnabledModules();
  return rule.modules.some((m) => enabled.includes(normalize(m)));
};
